"use client";

import { useEffect } from "react";

import NextError from "next/error";

import { logError } from "@/app/lib/utils/logging";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    logError(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
